import axios from "axios";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function catcherror(error) {
  if (error.response) {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/";
      toast.error("Session expired. Please login again.");
    } else {
      toast.error(error.response.data.message || "An error occurred");
    }
  } else {
    toast.error("Network error. Please check your connection.");
  }
}

export async function clockIn() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/clockin`, {}, { headers: header })
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
        }
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
        throw error;
      });
  } catch (error) {
    catcherror(error);
    throw error;
  }
}

export async function clockOut(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/clockout`, data, { headers: header })
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
        }
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
        throw error;
      });
  } catch (error) {
    catcherror(error);
    throw error;
  }
}

export async function getAttendanceStatus() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/attendancestatus`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getAttendanceList(params) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/attendancelist`, { headers: header, params })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getAttendanceStaffList() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/attendancestafflist`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
